import axios from 'axios';
import * as configuredStore from '../store';
import * as AuthUtils from './auth';
const baseURL = ( process.env.REACT_APP_DEPLOYMENT_ENV === 'production' ) ? 'https://v2-api.kureapp.com:3000' : 'https://v3-api-dev.kureapp.com:3000';
const signinURL = ( process.env.REACT_APP_DEPLOYMENT_ENV === 'production' ) ? "https://chatapp.kureapp.com/signin" : "https://chatapp-dev.kureapp.com/signin";

var apiClientNode = axios.create({
    baseURL,
    timeout: 30000,
    headers: {
        'Content-Type': 'application/json'
    }
});


apiClientNode.interceptors.request.use(function (config) {
    let token = null;
    if(AuthUtils.getAuthCookie() && !config.headers['Authorization']){
        token = 'bearer ' + AuthUtils.getAuthCookie();
    }

    config.headers['Content-Type'] = 'application/json';
    config.headers['x-api-version'] = '1.0';
    if(config.headerData){
        Object.assign(config.headers, config.headerData);
    }
    if(config.removeHeaders){
        config.removeHeaders.forEach((header) => {
            delete config.headers[header];
        })
    }

    let existingAuth = config.headers && config.headers['Authorization'];
    if(existingAuth === "parentAuth"){
        token = null;
        delete config.headers['Authorization'];
    }
    
    if (token !== null) {
        config.headers['Authorization'] = `${token}`;
    }

    const accessToken = AuthUtils.getAccessToken();
    config.headers['access-token'] = `${accessToken}`;
    
    return config;
}, function (error) {
    return Promise.reject(error);
});

// Add a response interceptor
apiClientNode.interceptors.response.use(function (response) {
    return response.data; //Data has data field inside.
}, function (error) {
    // Do something with response error
    console.log('API error', error);

    let message;
    if(error.response){
        message = error.response.statusText;
    }else{
        message = error.message;
    }

    if(error.response && error.response.data.message) {
        message = error.response.data.message;
    }

    if (error.response && error.response.status === 406 && configuredStore && configuredStore.store) {
        AuthUtils.setTimeZoneCookie();

        AuthUtils.removeAuthCookie();
        window.location.href = signinURL;        
    } else if (error.response && (error.response.status === 401 || error.response.status === 403) && configuredStore && configuredStore.store) {
        AuthUtils.removeAuthCookie();
        // configuredStore.store.dispatch(UserActions.logoutUser());
        window.location.href = signinURL;
    }

    return Promise.reject(message);
});

export {
    apiClientNode
};
